export default __webpack_public_path__ + "static/media/benefit_07.82fc8c59.svg";